import { useState, useEffect } from "react";
import { isOnline as platformIsOnline, addNetworkListener, removeNetworkListener } from "../lib/platform";

/**
 * Track browser/native online/offline status.
 * @returns {{ isOnline: boolean }}
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(platformIsOnline());

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    addNetworkListener("online", goOnline);
    addNetworkListener("offline", goOffline);
    return () => {
      removeNetworkListener("online", goOnline);
      removeNetworkListener("offline", goOffline);
    };
  }, []);

  return { isOnline };
}
